"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _solarReact = require("@solar/solar-react");

var _ProductCard = _interopRequireDefault(require("./ProductCard"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ProductList = function ProductList(_ref) {
  var products = _ref.products,
      openProduct = _ref.openProduct,
      noAvatar = _ref.noAvatar;
  return /*#__PURE__*/_react["default"].createElement(_solarReact.CardList, {
    items: R.sortBy(R.prop('number'))(products)
  }, function (_ref2) {
    var _id = _ref2._id,
        key = _ref2.key,
        cover = _ref2.cover,
        renderCodes = _ref2.renderCodes,
        title = _ref2.title,
        renderTitle = _ref2.renderTitle;
    return /*#__PURE__*/_react["default"].createElement(_ProductCard["default"], {
      key: key,
      coverSrc: cover && cover.src,
      title: key,
      subheader: title,
      onOpen: function onOpen() {
        return openProduct(_id);
      },
      nbCertificates: 0,
      noAvatar: noAvatar
    });
  });
};

ProductList.propTypes = {
  openProduct: _propTypes["default"].func
};
var _default = ProductList;
exports["default"] = _default;